/* GWP listicle landing page: offer card selection, option pills, sticky CTA, smooth anchor scroll. */
(function () {
  "use strict";

  if (window.__gwpLandingLoaded) return;
  window.__gwpLandingLoaded = true;

  var TELEMETRY_ENDPOINT = "https://zernio-dm-throttler.holistic-wellness-ebooks.workers.dev/api/shopify/storefront-events";
  var TOKEN_PATTERN = /^[a-z0-9][a-z0-9_-]{0,79}$/;
  var ACCOUNT_ID_PATTERN = /^[0-9a-f]{24}$/;
  var NUMERIC_ID_PATTERN = /^[1-9][0-9]{0,19}$/;
  var SKU_PATTERN = /^[A-Z0-9-]{1,100}$/;
  var PLATFORMS = ["facebook", "instagram"];

  function telemetryContext() {
    var params = new URLSearchParams(window.location.search);
    function single(key) {
      var values = params.getAll(key);
      return values.length === 1 ? values[0] : "";
    }
    function optionalToken(key) {
      var value = single(key).toLowerCase();
      return TOKEN_PATTERN.test(value) ? value : "";
    }
    var accountId = single("zernio_account_id").toLowerCase();
    var platform = single("utm_source").toLowerCase();
    if (!ACCOUNT_ID_PATTERN.test(accountId) || PLATFORMS.indexOf(platform) === -1
      || !window.crypto || typeof window.crypto.randomUUID !== "function") return null;
    return {
      accountId: accountId,
      platform: platform,
      campaign: optionalToken("utm_campaign"),
      landingVariantId: optionalToken("landing_variant_id"),
      creativeAngleId: optionalToken("creative_angle_id")
    };
  }

  function sendTelemetry(context, cta, eventType, ctaPosition) {
    if (!context || !cta) return;
    var productId = cta.getAttribute("data-product-id") || "";
    var variantId = cta.getAttribute("data-variant-id") || "";
    var sku = cta.getAttribute("data-sku") || "";
    if (!NUMERIC_ID_PATTERN.test(productId) || !NUMERIC_ID_PATTERN.test(variantId)
      || !SKU_PATTERN.test(sku)) return;
    var body = {
      eventId: window.crypto.randomUUID(),
      eventType: eventType,
      productId: productId,
      variantId: variantId,
      sku: sku,
      accountId: context.accountId,
      platform: context.platform
    };
    if (context.campaign) body.campaign = context.campaign;
    if (context.landingVariantId) body.landingVariantId = context.landingVariantId;
    if (context.creativeAngleId) body.creativeAngleId = context.creativeAngleId;
    if (ctaPosition) body.ctaPosition = ctaPosition;
    try {
      var pending = window.fetch(TELEMETRY_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        mode: "cors",
        credentials: "omit",
        referrerPolicy: "no-referrer",
        keepalive: true
      });
      if (pending && typeof pending.catch === "function") pending.catch(function () {});
    } catch (_error) {
      // Telemetry must never delay or interrupt checkout.
    }
  }

  function initOfferBox(box) {
    if (box.dataset.gwpOfferReady === "true") return;
    box.dataset.gwpOfferReady = "true";
    var plans = Array.prototype.slice.call(box.querySelectorAll("[data-gwp-plan]"));
    var cta = box.querySelector("[data-gwp-cta]");
    var shortcuts = Array.prototype.slice.call(document.querySelectorAll('.gwp-scope a.gwp-btn[href="#offers"]'));
    shortcuts = shortcuts.filter(function (link) { return link !== cta; });

    function syncPurchaseLinks() {
      if (!cta) return;
      var href = cta.getAttribute("href") || "";
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/[1-9][0-9]*:1(?:,[1-9][0-9]*:1)*(?:\?[^#]*)?$/.test(href)) return;
      shortcuts.forEach(function (link) {
        link.setAttribute("href", href);
        link.setAttribute("data-gwp-checkout-shortcut", "");
        ["data-product-id", "data-variant-id", "data-sku"].forEach(function (key) {
          link.setAttribute(key, cta.getAttribute(key) || "");
        });
      });
    }
    var options = Array.prototype.slice.call(box.querySelectorAll("[data-gwp-option]"));
    var discount = box.getAttribute("data-gwp-discount") || "";
    var cartPath = box.getAttribute("data-gwp-cart-path") || "/cart/";
    var giftVariantIds = (box.getAttribute("data-gwp-gift-variant-ids") || "")
      .split(",")
      .map(function (id) { return id.trim(); })
      .filter(Boolean);

    function cartUrl(variantId) {
      // Checkout displays cart permalink lines in reverse insertion order.
      // Insert gifts first so the selected main product is visible first.
      var lineIds = giftVariantIds.concat([variantId]);
      var url = cartPath + lineIds.map(function (id) { return id + ":1"; }).join(",");
      if (discount) {
        url += "?discount=" + encodeURIComponent(discount);
      }
      return url;
    }

    function selectPlan(plan) {
      plans.forEach(function (candidate) {
        candidate.setAttribute("aria-checked", candidate === plan ? "true" : "false");
      });
      if (cta && plan.getAttribute("data-variant-id")) {
        cta.setAttribute("href", cartUrl(plan.getAttribute("data-variant-id")));
        cta.setAttribute("data-product-id", plan.getAttribute("data-product-id") || "");
        cta.setAttribute("data-variant-id", plan.getAttribute("data-variant-id") || "");
        cta.setAttribute("data-sku", plan.getAttribute("data-sku") || "");
        syncPurchaseLinks();
      }
    }

    plans.forEach(function (plan) {
      plan.addEventListener("click", function () {
        selectPlan(plan);
      });
    });

    options.forEach(function (option) {
      option.addEventListener("click", function () {
        options.forEach(function (candidate) {
          candidate.setAttribute("aria-pressed", candidate === option ? "true" : "false");
        });
        var target = option.getAttribute("data-gwp-option-target");
        if (target) {
          var plan = box.querySelector('[data-gwp-plan][data-variant-title="' + target + '"]');
          if (plan) {
            selectPlan(plan);
          }
        }
      });
    });

    if (plans.length > 0) {
      var preselected = box.querySelector('[data-gwp-plan][aria-checked="true"]') || plans[0];
      selectPlan(preselected);
    }
    syncPurchaseLinks();

    var context = telemetryContext();
    if (!context || !cta) return;
    sendTelemetry(context, cta, "page_view");
    if (typeof window.IntersectionObserver === "function") {
      var observer = new window.IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        sendTelemetry(context, cta, "cta_impression", "checkout");
        observer.disconnect();
      }, { threshold: 0.25 });
      observer.observe(cta);
    }
    [cta].concat(shortcuts).forEach(function (link) {
      var opened = false;
      link.addEventListener("click", function () {
        if (opened) return;
        opened = true;
        sendTelemetry(context, cta, "cta_click", "checkout");
        sendTelemetry(context, cta, "checkout_exposure", "checkout");
      }, { capture: true });
    });
  }

  function initStickyCta(sticky) {
    if (sticky.dataset.gwpStickyReady === "true") return;
    sticky.dataset.gwpStickyReady = "true";
    var threshold = parseInt(sticky.getAttribute("data-gwp-sticky-after") || "600", 10);

    if (threshold === 0) {
      var regularCtas = Array.prototype.slice.call(document.querySelectorAll(
        '[data-cta-position], [data-gwp-cta], [data-sticky-cta-guard], a[href="#offers"]'
      )).filter(function (cta) {
        return !sticky.contains(cta);
      });

      function isVisibleInViewport(cta) {
        var styles = window.getComputedStyle(cta);
        if (styles.display === "none" || styles.visibility === "hidden") return false;
        var rect = cta.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.bottom > 0 &&
          rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
      }

      function updateForViewport() {
        var otherCtaVisible = regularCtas.some(isVisibleInViewport);
        sticky.classList.toggle("is-visible", !otherCtaVisible);
        sticky.setAttribute("aria-hidden", otherCtaVisible ? "true" : "false");
      }

      updateForViewport();

      if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(updateForViewport, { threshold: 0.01 });
        regularCtas.forEach(function (cta) { observer.observe(cta); });
      } else {
        window.addEventListener("scroll", updateForViewport, { passive: true });
      }
      window.addEventListener("resize", updateForViewport, { passive: true });
      return;
    }

    var visible = false;

    function onScroll() {
      var shouldShow = window.scrollY > threshold;
      if (shouldShow !== visible) {
        visible = shouldShow;
        sticky.classList.toggle("is-visible", visible);
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  function initAnchorScroll(scope) {
    var links = scope.querySelectorAll('a[href^="#"]');
    Array.prototype.forEach.call(links, function (link) {
      if (link.dataset.gwpAnchorReady === "true") return;
      link.dataset.gwpAnchorReady = "true";
      link.addEventListener("click", function (event) {
        var id = link.getAttribute("href").slice(1);
        var target = id && document.getElementById(id);
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? "instant" : "smooth", block: id === "offers" ? "center" : "start" });
        }
      });
    });
  }

  function init() {
    var boxes = document.querySelectorAll("[data-gwp-offer-box]");
    Array.prototype.forEach.call(boxes, initOfferBox);

    var stickies = document.querySelectorAll("[data-gwp-sticky]");
    Array.prototype.forEach.call(stickies, initStickyCta);

    var scopes = document.querySelectorAll(".gwp-scope");
    Array.prototype.forEach.call(scopes, initAnchorScroll);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();

